import React from "react";
import Button from '@material-ui/core/Button';
import FinalFormField from "../FinalFormField";
import { useField } from "react-final-form-hooks";
import UploadFile from "./UploadFile";



const UploadSingleFile = (props) => {
  const field = useField(props.name, props.form);
  const { input: { value, onChange }} = field;
  const { previewDivClassName, ...rest } = props;
  return (
    <div className="flex-row py-3 flex-wrap">
      <div className="flex flex-column">
        <FinalFormField {...rest} />
        <UploadFile onChange={onChange} accept="image/png, image/jpeg" sizeLimit={2097152} id={`file-${props.name}`}>
          <Button variant="outlined" color="primary" component="span">
            Upload New File
          </Button>
        </UploadFile>
        <div className="my-1 small">* Support jpg, jepg, png (below 2MB)</div>
      </div>
      <div className="p2 width-250 text-center">
        <div className="p1 border inline-block">
          <div className={previewDivClassName || "square-20 bg-contain"} style={{ backgroundImage: `url(${value})`}} />
        </div>
      </div>
    </div>
  );
};

export default UploadSingleFile;
